import { render } from "./AnagraficaView.vue?vue&type=template&id=731c77e8"
import script from "./AnagraficaView.vue?vue&type=script&lang=js"
export * from "./AnagraficaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__